module.exports = __webpack_public_path__ + "static/media/maleAgent.c89404b7.png";